import { Link, Paragraph } from '@vimeo/iris/typography';

export default function Projects() {
  return (
    <div>
      <Paragraph size="2">
        A <em>folder</em> (previously <em>project</em>) is a place to store videos for organization
        and collaboration, including integration with the{' '}
        <Link variant="minimal" href="https://www.slack.com/">
          Slack
        </Link>{' '}
        messaging platform. The set of features available for folders depends on the folder owner's
        membership level:
      </Paragraph>

      <ul>
        <li>
          <strong>Vimeo Free or Vimeo Starter.</strong> The folder's owner can add videos to the
          folder and sort them as needed, but the folder is visible to this account only.
        </li>
        <li>
          <strong>Vimeo Standard, Vimeo Advanced, or Vimeo Enterprise.</strong> The folder's owner
          (or any administrator on this person's team) can invite other team members to collaborate.
          Contributors can add new videos to the folder and manage existing videos. See our{' '}
          <Link
            variant="minimal"
            href="https://vimeo.com/help/sso?redirect_to=https://help.vimeo.com/hc/en-us/articles/12425434123793-Add-and-remove-team-members-on-your-account"
          >
            Help Center
          </Link>{' '}
          for more information.
        </li>
      </ul>

      <Paragraph size="2">
        When developing for this feature, keep in mind that our endpoint syntax uses the original{' '}
        <em>project</em> nomenclature, although this is subject to change in the future.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
